module.exports = __webpack_public_path__ + "img/apidays-2022.02fe35c7.png";